import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { getCohortsPath, getProjectsBasePath } from '@verantos-dev/core-constants';
import { useGetProjectQuery } from '@verantos-dev/data-access-projects';
import { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

export const useCohortListBreadCrumbs = (): PageHeaderBreadcrumb[] | undefined => {
  const intl = useIntl();
  const navigate = useNavigate();

  const { projectId } = useParams();
  const { data: projectData } = useGetProjectQuery(projectId || '', { skip: !projectId });

  return projectData?.data.projectName && projectId
    ? [
        {
          label: intl.formatMessage({
            id: 'projects.cohortsListPage.breadcrumbs.projects',
          }),
          onClick: () => navigate(getProjectsBasePath()),
        },
        {
          label: projectData.data.projectName || '',
          onClick: () => navigate(getCohortsPath(projectId)),
        },
        {
          label: intl.formatMessage({ id: 'projects.cohortsListPage.breadcrumbs.cohorts' }),
        },
      ]
    : undefined;
};
